export default __webpack_public_path__ + "static/media/integrations-link.81b37775.svg";